import React, { useEffect, useState } from 'react';
import { Table, Button, Modal, Form } from 'react-bootstrap';
import axios from 'axios';

const AdminFAQs = () => {
  const [faqs, setFaqs] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentFaq, setCurrentFaq] = useState({ title: '', desc: '', id: null });
  const [isEditing, setIsEditing] = useState(false);

  const fetchFaqs = async () => {
    try {
      const response = await axios.get('https://api.biznetusa.com/api/all-mainfaqs');
      setFaqs(response.data.mainfaqs);
    } catch (error) {
      console.error('Error fetching FAQs:', error);
    }
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  const handleShowModal = (faq = { title: '', desc: '', id: null }) => {
    setCurrentFaq(faq);
    setIsEditing(!!faq.id);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setCurrentFaq({ title: '', desc: '', id: null });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCurrentFaq({ ...currentFaq, [name]: value });
  };

  const handleSaveFaq = async () => {
    try {
      if (isEditing) {
        await axios.put(`https://api.biznetusa.com/api/update-mainfaqs/${currentFaq.id}`, currentFaq);
      } else {
        await axios.post('https://api.biznetusa.com/api/store-mainfaqs', currentFaq);
      }
      fetchFaqs();
      handleCloseModal();
    } catch (error) {
      console.error('Error saving FAQ:', error);
    }
  };

  const handleDeleteFaq = async (id) => {
    try {
      await axios.delete(`https://api.biznetusa.com/api/deletemainfaqs/${id}`);
      fetchFaqs();
    } catch (error) {
      console.error('Error deleting FAQ:', error);
    }
  };

  return (
    <div className="container mt-4">
      <h2 className="text-center">Manage FAQs</h2>
      <Button className="mb-3" onClick={() => handleShowModal()}>
        Add New FAQ
      </Button>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>Description</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {faqs.map((faq, index) => (
            <tr key={faq.id}>
              <td>{index + 1}</td>
              <td>{faq.title}</td>
              <td>{faq.desc}</td>
              <td>
                <Button
                  variant="info"
                  className="me-2"
                  onClick={() => handleShowModal(faq)}
                >
                  Edit
                </Button>
                <Button
                  variant="danger"
                  onClick={() => handleDeleteFaq(faq.id)}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Modal for Adding/Editing FAQ */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{isEditing ? 'Edit FAQ' : 'Add FAQ'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="faqTitle">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={currentFaq.title}
                onChange={handleInputChange}
                placeholder="Enter FAQ title"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="faqDesc">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="desc"
                value={currentFaq.desc}
                onChange={handleInputChange}
                placeholder="Enter FAQ description"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSaveFaq}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AdminFAQs;
